/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_UploadInputs */

const vi_media_upload = /** @type {(inputs: Media_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải lên`)
};

/**

* @param {Media_UploadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_upload = /** @type {((inputs?: Media_UploadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_UploadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_upload(inputs)
});